import { render, staticRenderFns } from "./panel-addtocart-settings.vue?vue&type=template&id=1873299c&"
import script from "./panel-addtocart-settings.vue?vue&type=script&lang=js&"
export * from "./panel-addtocart-settings.vue?vue&type=script&lang=js&"
import style0 from "./panel-addtocart-settings.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports